import React, {useState} from 'react';
import Paper from '@material-ui/core/Paper/Paper';
import List from '@material-ui/core/List/List';
import ListItem from '@material-ui/core/ListItem/ListItem';
import i18n from '../../i18n';
import {withStyles} from '@material-ui/core';
import Grid from '@material-ui/core/Grid/Grid';
import Typography from '@material-ui/core/Typography/Typography';
import EllipsisWithTooltip from '../Formater/EllipsisWithTooltip';
import {cleanPhone} from '../Form/utils';
import LinkIconButton from '../Formater/LinkIconButton';
import ProjectStatusText from './ProjectStatusText';
import Icon from '@material-ui/core/Icon';
import iconNames from '../Formater/IconNames';
import NotesList from '../Notes/NotesList';
import Button from '@material-ui/core/Button';
import RenderDetailsRow from '../Formater/RenderDetailsRow';
import moment from "moment";
import DocumentsTable from "../Media/Documents/DocumentsTable";
import FileUploadDialog from "./Dialogs/FileUploadDialog";

const renderDetailsRow = (label, value, classes) => {

    let phone = (value && value.landline) ? (value.landline && value.mobile) : null;
    let email = (value && value.email) && value.email;

    return (
        <ListItem key={Math.random()} dense className={classes.detailsRow}>
            <Grid container spacing={24}>
                <Grid item xs={4}>
                    <Typography
                        className={classes.detailsLabel}
                        component={'div'}
                        variant={'subtitle2'}>
                        {(<EllipsisWithTooltip>{label}</EllipsisWithTooltip>)}
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography
                        className={classes.detailsValue}
                        component={'div'}
                        variant={'body2'}>
                        {(phone || email) ? value.first_name + ' ' + value.last_name : value}
                        {phone && (
                            <LinkIconButton
                                href={`tel:${cleanPhone(phone)}`}
                                text={phone}
                                icon={'phone'}
                                fontSize={'small'}
                                buttonProps={{style:{display: 'lowercase'}}}
                            />
                        )}
                        {email && (
                            <LinkIconButton
                                buttonProps={{style:{textTransform: 'lowercase'}}}
                                href={`mailto:${email}`}
                                text={email}
                                icon={'email'}
                                fontSize={'small'}
                            />
                        )}
                    </Typography>
                </Grid>
            </Grid>
        </ListItem>
    );
};


const ProjectDetails = (props) => {
    const {
        project,
        files,
        notes,
        uploadConfig,
        classes,
    } = props;

    //let classesButtonAble = {details: classes.details, detailsLabel: classes.detailsLabel};
    let noteList = notes.data || notes;

    const projectBuilding = project['project_building'] ? project['project_building'] : null;
    const building = projectBuilding ? projectBuilding.building : null;
    const apartment = projectBuilding ? projectBuilding.apartment : null;

    const address =  building.street && building.number && (', ' + building.street + ' ' + building.number);
    const buildingName = building.name && ( building.name + ( address ? address : '' ) );
    const buildingParent = building && building.parent;
    const buildingParentName = buildingParent && buildingParent.name

    const subcontractor = project.contacts[0] && project.contacts[0].contact;
    const subcontractorName = subcontractor && subcontractor.company_name;
    const clientNote = project.client_note && moment( project.client_note ,'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    const deadline = project.deadline && moment( project.deadline ,'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    const firstGracePeriod = project.first_grace_period && moment( project.first_grace_period ,'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    const secondGracePeriod = project.second_grace_period && moment( project.second_grace_period ,'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    const reminder = project.reminder && moment( project.reminder ,'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');

    const user = project.owner && project.owner.name;
    const apartmentNumber = apartment && apartment.number && apartment.number;
    const apartmentStorey = apartment && apartment.storey && apartment.storey;
    const tenantName = apartment && apartment.tenant_name && apartment.tenant_name;
    const phoneNumber = apartment && apartment.tenant_phone_number && apartment.tenant_phone_number;

    const [dialog,setDialog] = useState({open :false});
    const openDialog = () => {
        setDialog({ open :true});
    };
    const closeDialog = () => {
        setDialog( { open :false } );
    };

    return (
        <React.Fragment>
            <Grid container spacing={24} className={classes.vSpace}>
                <Grid item xs={12} md={6}>
                    <Paper className={classes.spaces}>
                        <div className={classes.details}>
                            <List className={classes.fullWidth}>
                                {building.parent && (
                                    <RenderDetailsRow label={i18n.get('building.construction_project')} value={ buildingParentName }>
                                            <LinkIconButton
                                                text={buildingParentName}
                                                href={`/construction/${building.parent.id}`}
                                                icon={iconNames.building}
                                            />
                                    </RenderDetailsRow>
                                )}
                                {building && (
                                    <RenderDetailsRow label={i18n.get('building.self')} value={ buildingName }>
                                        <LinkIconButton
                                            text={buildingName}
                                            href={`/construction/${building.id}`}
                                            icon={iconNames.building}
                                        />
                                    </RenderDetailsRow>
                                )}
                                {project.number_client && renderDetailsRow(i18n.get('deficiency.number_client'),project.number_client, classes )}
                                {project.number_internal && renderDetailsRow(i18n.get('deficiency.number_internal'),project.number_internal, classes )}
                                {subcontractor && (
                                    <RenderDetailsRow label={i18n.get('deficiency.subcontractor')} value={ subcontractorName }>
                                        <LinkIconButton
                                            text={subcontractorName}
                                            href={`/contacts/craft/${subcontractor.id}`}
                                            icon={iconNames.company}
                                        />
                                    </RenderDetailsRow>
                                )}
                                {subcontractor && renderDetailsRow(i18n.get('deficiency.subcontractor'), subcontractorName , classes )}

                                {clientNote && renderDetailsRow(i18n.get('deficiency.dates.client_note'), clientNote ,classes)}
                                {deadline && renderDetailsRow(i18n.get('deficiency.dates.deadline_for_completion'), deadline ,classes)}
                                {firstGracePeriod && renderDetailsRow(i18n.get('deficiency.dates.first_grace_period'), firstGracePeriod ,classes)}
                                {secondGracePeriod && renderDetailsRow(i18n.get('deficiency.dates.second_grace_period'), secondGracePeriod ,classes)}
                            </List>
                        </div>
                    </Paper>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Paper className={classes.spaces} style={{height:'100%'}}>
                        <div className={classes.details}>
                            <List className={classes.fullWidth}>
                                {project.status && renderDetailsRow(i18n.get('project.status'), <ProjectStatusText status={project.status}/> , classes )}
                                {reminder && renderDetailsRow(i18n.get('deficiency.dates.next_reminder'), reminder ,classes)}
                                {user && renderDetailsRow(i18n.get('deficiency.editor'), user ,classes)}
                                {apartmentNumber && renderDetailsRow(i18n.get('deficiency.apartment_number'), apartmentNumber ,classes)}
                                {apartmentStorey && renderDetailsRow(i18n.get('deficiency.storey'), apartmentStorey ,classes)}
                                {tenantName && renderDetailsRow(i18n.get('deficiency.tenant.name'), tenantName ,classes)}
                                {phoneNumber &&
                                    <RenderDetailsRow label={i18n.get('deficiency.tenant.phone_number')} value={ phoneNumber }>
                                        <LinkIconButton
                                            href={`tel:${cleanPhone(phoneNumber)}`}
                                            text={phoneNumber}
                                            icon={'phone'}
                                            fontSize={'small'}
                                            buttonProps={{style:{display: 'lowercase'}}}
                                        />
                                    </RenderDetailsRow>
                                }
                            </List>
                        </div>
                    </Paper>
                </Grid>

                <Grid item xs={12}>
                    <Paper className={classes.spaces}>
                        <Grid container spacing={24} direction={'row'} alignItems={'flex-start'}>
                            <Grid item xs>
                                <Typography variant="h6" color={"primary"}>{i18n.get('deficiency.documents')}</Typography>
                            </Grid>
                            {/*
                            <Grid item xs align={'right'}>
                                <Button
                                    size={"small"}
                                    component={'a'}
                                    variant={"contained"}
                                    type={'button'}
                                    color={"primary"}
                                    onClick={openDialog}
                                >
                                    <Icon fontSize="small">add</Icon>
                                    &nbsp;
                                    {i18n.get('deficiency.upload_file')}
                                </Button>
                            </Grid>
                            */}
                        </Grid>
                        {files && files.length > 0 ? (
                            <DocumentsTable entity={{label:'project_id', id: project.id }} files={files} />
                        ): ( <div>{i18n.get('default.empty')}</div> )}
                    </Paper>
                </Grid>


                <Grid item xs={12}>
                    <Paper className={classes.spaces}>
                        <Grid container spacing={24} justify="space-between" alignItems="center">
                            <Grid item xs>
                                <Typography variant="h6" color={"primary"}>{i18n.get('project.notes')}</Typography>
                            </Grid>
                            <Grid item xs align={'right'}>
                                <Button
                                    color={'primary'}
                                    variant={'contained'}
                                    component={'a'}
                                    href={`/notes/create?project_id=${project.id}`}
                                    icon={'add'}
                                    size={'small'}
                                >
                                    <Icon>add</Icon>
                                    &nbsp;
                                    {i18n.get('notes.note_add')}
                                </Button>
                            </Grid>
                        </Grid>

                        {noteList && noteList.length > 0 ? (
                            <NotesList notes={noteList.map((item) => {
                                /*console.log({...item});*/
                                return {
                                    ...item,
                                    ...item.note,
                                };
                            })}/>
                        ) : i18n.get('default.empty')}
                    </Paper>
                </Grid>
            </Grid>
            <FileUploadDialog closeDialog={closeDialog} dialog={dialog} uploadConfig={uploadConfig} />
        </React.Fragment>
    );
}

const styles = theme => ({
    previewIcon: {
        textAlign: 'center',
    },
    spaces: {
        padding: theme.spacing.unit * 1.5,
    },
    vSpace: {
        marginTop: theme.spacing.unit * 1.5,
        marginBottom: theme.spacing.unit * 1.5,
    },
    fullWidth: {
        width: '100%',
    },
    details: {
        display: 'flex',
        flexDirection: 'row',
        padding: 0,
        '&:last-child': {
            padding: 0,
        },
    },
    detailsLabel: {
        textAlign: 'right',
    },
    detailsValue: {
        '& > *': {
            ...theme.helpers.oneLiner,
        },
    },
});

export default withStyles(styles)(ProjectDetails);
